/**
 * @generated SignedSource<<c3be61d39b9735b0029cb1f14cf9d708>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSageCompanyInput = {
  email?: string | null;
  companyName?: string | null;
  unlinkedSageCustomerID?: string | null;
  projectFinancialsAccess?: boolean | null;
  revenueAccess?: boolean | null;
  financeMenuAccess?: boolean | null;
  reportingAccess?: boolean | null;
  timesheetsAccess?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateSageCompanyMutation$variables = {
  input: CreateSageCompanyInput;
};
export type CreateSageCompanyMutation$data = {
  readonly CreateSageCompany: {
    readonly resultCode: string | null;
    readonly companyId: string | null;
  } | null;
};
export type CreateSageCompanyMutation = {
  variables: CreateSageCompanyMutation$variables;
  response: CreateSageCompanyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSageCompanyPayload",
    "kind": "LinkedField",
    "name": "CreateSageCompany",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resultCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companyId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSageCompanyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSageCompanyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f5f44292bb3bc2f123536157188bfdd6",
    "id": null,
    "metadata": {},
    "name": "CreateSageCompanyMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSageCompanyMutation(\n  $input: CreateSageCompanyInput!\n) {\n  CreateSageCompany(input: $input) {\n    resultCode\n    companyId\n  }\n}\n"
  }
};
})();

(node as any).hash = "008e721077f05207fe6e8a72119ff940";

export default node;
